import styles from "./guides.module.css";

const GuideLinkData = ({ link, text, label }) => {
  return (
    <div className="row">
      {label != "" ? (
        <div className={`${styles.wrap} label mb-025`}>{label}</div>
      ) : (
        <></>
      )}
      <a className="link" href={link} target="_blank" rel="noopener noreferrer">
        {text}
      </a>
    </div>
  );
};
export default GuideLinkData;
